import { useApiSend } from "@/hooks/useApi";
import { unwatchModule } from "../api";
import { useQueryClient } from "@tanstack/react-query";

export function useUnwatchModule({ courseSlug }) {
	const queryClient = useQueryClient();

	const { mutateAsync, isPending, isError, error } = useApiSend({
		fn: ({ moduleSlug }) => unwatchModule({ courseSlug, moduleSlug }),
	});

	return {
		unwatchModule: async ({ moduleSlug }) => {
			await mutateAsync({ moduleSlug });
			queryClient.invalidateQueries({
				queryKey: ["courses", courseSlug, "units", "list"],
			});

			queryClient.invalidateQueries({
				queryKey: [
					"courses",
					courseSlug,
					"modules",
					moduleSlug,
					"units",
				],
			});
		},
		isPending,
		error,
		isError,
	};
}
